import { useState, useRef, useEffect } from 'react';
import { motion, useAnimation } from "framer-motion"
import MobileFooter from '../components/MobileFooter';



function Home(props) {
    const framerControls = useAnimation();
    const indexRef = useRef(0);
    const [iFrameLoaded, setiFrameLoaded] = useState(false);
    const [videoData, setVideoData] = useState();
    const [videoUrl, setVideoUrl] = useState("");

   const loadVideo = () => {
        let currentVideo = props.data.tokensData.find(e=>e.id==props.data.previews[indexRef.current]);
        setVideoData(currentVideo);
        setVideoUrl(`player/?fullscreen=true&id=${parseFloat(currentVideo.id)}`);
    }

    const handleVideoClick = async () => {
        await framerControls.start(props.framer.fade.initial);
        setiFrameLoaded(false);
        indexRef.current = (indexRef.current+1)%props.data.previews.length;
        loadVideo();
    }

    useEffect(()=> {
        loadVideo();
        window.addEventListener("message", function(event) {
            if (event.origin == window.origin) {
                if (event.data.shaderloaded) {
                    setiFrameLoaded(true) 
                }
            }
          })
    },[]);

    useEffect(() => { 
       if (iFrameLoaded) {framerControls.start(props.framer.fade.animate)}
    }, [iFrameLoaded]);
    return (
        <section className="pt-4 pl-4 pb-4 pr-4 home">
            <motion.div className="columns is-desktop is-gapless is-paddingless" {...props.framer.slide}>
                <motion.div className="column mr-4 dtraits is-narrow is-hidden-mobile is-hidden-tablet-only is-uppercase has-text-left" initial={props.framer.fade.initial} animate={framerControls} >
                    {videoData && (
                        <ul>
                            <li>⬤ {props.data.stats.mintlabel} {videoData.id}</li>
                            <li>⬤ Style: {videoData.Style}</li>
                            <li>⬤ Palette: {videoData.Palette}</li>
                        </ul>
                    )}                
                </motion.div>
                <motion.div className="column" onClick={handleVideoClick} initial={props.framer.fade.initial} animate={framerControls} >
                    <div className='dplayer-container'>
                    <div className='dplayer-outside'>
                    <iframe 
                        className="dplayer-inside" 
                        frameBorder={0} 
                        allowtransparency="true" 
                        title="Drifting video player"
                        //  onLoad={()=>setiFrameLoaded(true)} 
                         src={videoUrl} 
                        />
                    </div>
                    </div>
                    <div className="dplayer-cover"></div>
                </motion.div>
            </motion.div>
            {props.mobile&&<MobileFooter {...props} />}
        </section>
    )
}
export default Home;


/*
<video loop autoPlay>
                    <source  type="video/mp4" />
                </video>
*/


// const prepareUrlFromHash = (hash, id) => {
//     let pwd = (()=>{
//         let x = "0123456789abcdef", hash = '0x'
//         for (let i = 4; i > 0; --i) { hash += x[Math.floor(Math.random()*x.length)]}
//         return hash
//     })();
//     return `player/?fullscreen=true&hash=${hash + pwd}`;
// }
